import { Stack, SxProps, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

export interface ITextItem {
  textData: string;
  textSx?: SxProps;
  onClick?: Function;
}

interface ITextBlock {
  sx?: SxProps;
  texts: ITextItem[];
}

export const TextBlock = ({ sx, texts }: ITextBlock) => {
  const isDesktop = useIsDesktop();

  const defaultStyle: SxProps = {
    textAlign: 'center',
  };

  return (
    <Stack direction='column' sx={sx}>
      {texts.map((textItem: ITextItem, index: number) => {
        return (
          <Typography
            key={index}
            sx={{ ...defaultStyle, ...textItem.textSx }}
            onClick={() => (textItem.onClick ? textItem.onClick() : undefined)}
            variant={isDesktop ? 'body3' : 'body2'}
          >
            {textItem.textData}
          </Typography>
        );
      })}
    </Stack>
  );
};
